import { formatDate, groupItems } from '@utils';

export const getHandoverCarsPayload = (payload = {}) => {
  if (payload.assignee) {
    if (typeof payload.assignee === 'string') {
      payload.assignee = payload.assignee === 'none' ? '' : payload.assignee;
    }
    if (Array.isArray(payload.assignee)) {
      payload.assignee = payload.assignee.map((assignee) =>
        assignee === 'none' ? '' : assignee
      );
    }
  }

  return payload;
};

export const handleHandoveredCars = (data, groupType) => {
  if (!data) {
    return [];
  }
  const res = data?.map?.((item) => {
    let subscriberName = '';
    if (item?.plate) {
      return item;
    }
    item?.subscribers?.forEach((sub) => {
      sub?.subscriptions?.forEach((subsciption) => {
        if (subsciption?.role === 1) {
          subscriberName = sub?.firstName
            ? `${sub?.firstName} ${sub?.lastName}`
            : '-';
        }
      });
    });

    return {
      plate: item?.vehicle?.plate || '-',
      subscriber: subscriberName,
      image: item?.vehicle?.images?.[0]?.url,
      deliveryDate: item.deliveryDate
        ? formatDate(item.deliveryDate, 'dd.MM.yyyy')
        : '-',
      deliveryTime: item.deliveryDate
        ? formatDate(item.deliveryDate, 'HH:mm')
        : '-',
      rawDeliveryDate: item.deliveryDate,
      hasDeliveryTenancyAgreement: !!item?.deliveryInfo?.tenancyAgreement,
      returnDate: item.returnDate
        ? formatDate(item.returnDate, 'dd.MM.yyyy')
        : '-',
      returnTime: item.returnDate ? formatDate(item.returnDate, 'HH:mm') : '-',
      rawReturnDate: item.returnDate,
      hasReturnTenancyAgreement: !!item?.returnInfo?.tenancyAgreement,

      id: item.id,
      subscriptionType: item.type, // SUBSCRIPTIONS_TYPES[item.type],
      isUnsigned: item.contractSigned === false,
    };
  });

  const groupTypeByDate = groupItems(res, groupType, 'desc');

  return groupTypeByDate;
};

export const handleSubscription = (data) => {
  if (!data) {
    return null;
  }

  const billingInfoORKmMissing =
    (!data?.billingInfo?.firstName ||
      data?.deliveryInfo?.kmFuelTiresCheck?.km <= 0) &&
    'Please make sure that the Billing Information and the Delivery Km Field of the Subscription has been filled';
  const deliveryDateMissing =
    !data?.deliveryDate &&
    'Please make sure that the Delivery Date of the Subscription has been filled';

  const deliveryDetails = [];
  const returnDetails = [];

  const getDriverFields = (subscriber) => [
    {
      label: 'name',
      value: `${subscriber?.firstName} ${subscriber?.lastName}`,
    },
  ];

  const getLesseeFields = (billingInfo) => [
    {
      label: 'name',
      value: billingInfo?.firstName
        ? `${billingInfo?.firstName} ${billingInfo?.lastName}`
        : `${billingInfo?.companyName}`,
    },
  ];

  const getVehicleDetailsFields = (vehicle) => [
    {
      label: 'plate',
      value: vehicle?.plate || '-',
    },
    {
      label: 'brandModel',
      value: `${vehicle?.manufacturer || '-'} ${vehicle?.model}`,
    },
    {
      label: 'color',
      value: `${vehicle?.properties?.color || '-'}`,
    },
  ];

  const getKmFields = (kmFuelTiresCheck) => [
    {
      label: 'delivery',
      value: kmFuelTiresCheck?.km || '-',
    },
  ];

  const getFuelFields = (kmFuelTiresCheck) => [
    {
      label: 'delivery',
      value: kmFuelTiresCheck?.fuel || '-',
    },
  ];

  const getTiresFields = (tire) => [
    {
      label: 'Position',
      value: tire?.position || '-',
    },
    {
      label: 'dimensions',
      value: tire?.dimensions || '-',
    },
    {
      label: 'DOT',
      value: tire?.dot || '-',
    },
  ];

  data?.subscribers?.forEach((subscriber, index) => {
    if (subscriber.activeDriver) {
      deliveryDetails?.push({
        title: `driver${index + 1}`,
        isSelected: subscriber?.id === data?.deliveryInfo?.userId,
        fields: getDriverFields(subscriber),
      });
      returnDetails?.push({
        title: `driver${index + 1}`,
        isSelected: subscriber?.id === data?.returnInfo?.userId,
        fields: getDriverFields(subscriber),
      });
    }
  });

  deliveryDetails?.push({
    title: 'lessee',
    isSelected: false,
    fields: getLesseeFields(data?.billingInfo),
  });
  returnDetails?.push({
    title: 'lessee',
    isSelected: false,
    fields: getLesseeFields(data?.billingInfo),
  });
  deliveryDetails?.push({
    title: 'vehicleDetails',
    isSelected: false,
    fields: getVehicleDetailsFields(data?.vehicle),
  });
  returnDetails?.push({
    title: 'vehicleDetails',
    isSelected: false,
    fields: getVehicleDetailsFields(data?.vehicle),
  });
  deliveryDetails?.push({
    title: 'km',
    isSelected: false,
    fields: getKmFields(data?.deliveryInfo?.kmFuelTiresCheck),
  });
  returnDetails?.push({
    title: 'km',
    isSelected: false,
    fields: getKmFields(data?.returnInfo?.kmFuelTiresCheck),
  });
  deliveryDetails?.push({
    title: 'fuel',
    isSelected: false,
    fields: getFuelFields(data?.deliveryInfo?.kmFuelTiresCheck),
  });
  returnDetails?.push({
    title: 'fuel',
    isSelected: false,
    fields: getFuelFields(data?.returnInfo?.kmFuelTiresCheck),
  });
  data?.deliveryInfo?.kmFuelTiresCheck?.tires?.forEach((tire) => {
    deliveryDetails?.push({
      title: 'tires',
      isSelected: false,
      fields: getTiresFields(tire),
    });
  });

  data?.returnInfo?.kmFuelTiresCheck?.tires?.forEach((tire) => {
    returnDetails?.push({
      title: 'tires',
      isSelected: false,
      fields: getTiresFields(tire),
    });
  });

  return {
    ...data,
    cannotMakeDeliveryReason: !data?.billingInfo?.firstName
      ? 'Please make sure that the Billing Information of the Subscription has been filled'
      : null,
    cannotMakeReturnReason:
      billingInfoORKmMissing || deliveryDateMissing || null,
    deliveryInfoDriversDetails: deliveryDetails,
    returnInfoDriversDetails: returnDetails,
  };
};
